import { render, staticRenderFns } from "./SmartSwitch.vue?vue&type=template&id=b1ee7fe6&scoped=true&"
import script from "./SmartSwitch.vue?vue&type=script&lang=js&"
export * from "./SmartSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SmartSwitch.vue?vue&type=style&index=0&id=b1ee7fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ee7fe6",
  null
  
)

component.options.__file = "SmartSwitch.vue"
export default component.exports